import { render, staticRenderFns } from "./NewNpoForm.vue?vue&type=template&id=224c9b47&scoped=true&"
import script from "./NewNpoForm.vue?vue&type=script&lang=js&"
export * from "./NewNpoForm.vue?vue&type=script&lang=js&"
import style0 from "./NewNpoForm.vue?vue&type=style&index=0&id=224c9b47&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224c9b47",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VForm,VRow})
